import { render, staticRenderFns } from "./brokerage-tab-loader.vue?vue&type=template&id=3fa2af5e"
import script from "./brokerage-tab-loader.vue?vue&type=script&lang=js"
export * from "./brokerage-tab-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports